<!--<nav class="talent-payroll-breadcrumb breadcrumb">
  <ul>
    <li><a href="/tpm" title="Home">Home</a></li>
    <li>/</li>
    <li><a href="/TalentPayroll/Dashboard/TalentPayrollTimesheetTemplate/{{template.businessUnit.id}}" title="Templates">Templates</a></li>
    <li>/</li>
    <li style="color: #337ab7;">Template Details</li>
  </ul>
</nav>-->
 
<ol class="talent-payroll-breadcrumb breadcrumb">
  <ng-container  *ngFor="let breadcrumb of newBreadcrumbs_ ; last as isLast;first as isFirst">
    <li *ngIf="breadcrumb.label !='dashboard' && breadcrumb.label != undefined" 
    [ngStyle]="!isLast ? {'color': '#337ab7', 'font-size': '12px'} : {'color': '#000', 'font-size': '12px'}"
        class="breadcrumb-item"
        aria-current="page">
      <a #midRoutes *ngIf="!isLast; else lastRoute"
          class="btn-link"
         routerLink="{{breadcrumb.url}}">{{ breadcrumb.label }}</a><ng-template #lastRoute>{{ breadcrumb.label }}</ng-template>
    </li>
  </ng-container>
</ol>
